module.exports = __webpack_public_path__ + "img/step-5.2336fb88.jpg";